import { useFavoritesContext } from "../context/FavoritesContext";

function useFavorites() {
  return useFavoritesContext();
}

export default useFavorites;
